import "@/user/common";
import "@/shared/privacy_check";
import $ from "jquery";
import { sliderSetting } from "@/shared/calendar";
import "./progress";

/**
 * フェア開催時刻の選択肢を生成
 *
 * @param target
 * @param date 選択したフェア日
 */
const setFairTimes = (target, date) => {
  // 予約可能な時間
  const cvFormElement = document.getElementById("cv_form");
  const fairTimes = cvFormElement?.dataset.fairTimes;
  if (fairTimes === undefined) {
    return;
  }

  let fairTimesData;
  try {
    fairTimesData = JSON.parse(fairTimes);
  } catch (e) {
    fairTimesData = fairTimes;
  }

  const times = fairTimesData[date] || [];

  // 選択肢の作成
  // eslint-disable-next-line no-param-reassign
  target.innerHTML = "";
  let optionTags = '<option value="">時間を選択</option>';
  times.forEach((time) => {
    optionTags += `<option value="${time}">${time}～</option>`;
  });

  // eslint-disable-next-line no-param-reassign
  target.innerHTML = optionTags;
};

/**
 * フェアの開催日の開催時間の選択肢をセット
 */
const initFairTimes = () => {
  const preferredDate1Element = document.getElementById("preferred_date1");
  const preferredDate2Element = document.getElementById("preferred_date2");
  const reserveTime1Element = document.getElementById("reserve_time1");
  const reserveTime2Element = document.getElementById("reserve_time2");

  if (preferredDate1Element?.value && reserveTime1Element) {
    setFairTimes(reserveTime1Element, preferredDate1Element.value);
    // バリデートエラー時に直近の選択を表示
    if (reserveTime1Element) {
      const oldValue = reserveTime1Element.dataset.old;
      if (oldValue) {
        reserveTime1Element.value = oldValue;
        reserveTime1Element.dispatchEvent(new Event("change")); // 進捗表示用にエラー後に時間をセットし直した際にchangeイベント発火させる
      }
    }
  }
  if (preferredDate2Element?.value && reserveTime2Element) {
    setFairTimes(reserveTime2Element, preferredDate2Element.value);
    if (reserveTime2Element) {
      const oldValue = reserveTime2Element.dataset.old;
      if (oldValue) {
        reserveTime2Element.value = oldValue;
        reserveTime2Element.dispatchEvent(new Event("change")); // 進捗表示用にエラー後に時間をセットし直した際にchangeイベント発火させる
      }
    }
  }
};

/**
 * ご婚礼予定月の選択可能不可能の表示分け
 */
const toggleMarriageMonthDisabled = () => {
  const formMarriageMonth = document.querySelector("#marriage_month");
  const formMarriageYear = document.querySelector("#marriage_year");

  // 年で未定を選択した場合
  if (Number.isNaN(Number(formMarriageYear.value))) {
    formMarriageMonth.disabled = true;
    // 月の選択肢を未入力の状態に戻す
    formMarriageMonth.value = "";
  } else {
    formMarriageMonth.disabled = false;
  }
};

/**
 * 特典一覧のアコーディオンの開閉に速度をつける
 */
const privilegeAccordionAnimation = () => {
  const $privilegeDetails = $(".js-reserve-privilege");
  const privilegeSummary = document.querySelector(
    ".js-reserve-privilege__summary",
  );
  const $privilegeList = $(".js-reserve-privilege__list");

  document.addEventListener("DOMContentLoaded", () => {
    $privilegeList.slideUp(0);
  });

  privilegeSummary?.addEventListener("click", (e) => {
    e.preventDefault();
    if ($privilegeDetails.attr("open") === undefined) {
      $privilegeDetails.attr("open", true);
      $privilegeList.hide().slideDown(500);
    } else {
      $privilegeList.slideUp(500, () => {
        $privilegeDetails.removeAttr("open");
      });
    }
  });
};

document.addEventListener("DOMContentLoaded", () => {
  // フェア予約の場合、時間の選択肢をセット
  initFairTimes();

  // カレンダー初期表示
  sliderSetting(false, false);

  // ご婚礼予定月の選択可能不可能の表示分け
  if (document.querySelector("#marriage_month")) {
    toggleMarriageMonthDisabled();
  }

  // 特典一覧のアコーディオンの開閉に速度をつける
  privilegeAccordionAnimation();

  // 日付選択にフォーカスした
  let dateTarget = null; // 選択中の input

  document.querySelectorAll(".form-date__input").forEach((element) => {
    element.addEventListener("focus", (e) => {
      dateTarget = e.currentTarget;
      // カレンダーを表示（slick関連のためjQueryを使用）
      $(".calendar, .calendar__bg").show();
      $(".js-slick__list.slick-initialized").slick("setPosition"); // 非表示要素にslick再適応
    });
  });

  // 希望日を選択した
  const calendar = document.querySelector(".calendar");
  if (calendar) {
    calendar.addEventListener("click", (e) => {
      const target = e.target.closest(".calendar__day-item:not(.is-disabled)");
      if (target && calendar.contains(target)) {
        const inputElement = target.querySelector("input");
        const date = inputElement?.value;
        if (date && date.length) {
          // フォームに日付の入力
          if (dateTarget) {
            dateTarget.value = date;
            // 進捗表示用に日付セットした際にchangeイベント発火させる
            dateTarget.dispatchEvent(new Event("change"));
          }

          // フェア予約の場合、選択可能時刻を更新する
          if (dateTarget) {
            const timeTargetId = dateTarget.id.replace(
              "preferred_date",
              "reserve_time",
            );
            const timeTargetElement = document.getElementById(timeTargetId);
            if (timeTargetElement) {
              setFairTimes(timeTargetElement, date);
            }
          }

          // 日付のチェック解除
          const checkboxes = document.querySelectorAll(
            ".calendar__day-item input[type='checkbox']",
          );
          checkboxes.forEach((checkbox) => {
            // eslint-disable-next-line no-param-reassign
            checkbox.checked = false;
          });

          // カレンダー閉じる（slick関連のためjQueryを使用）
          $(".calendar, .calendar__bg").hide();
        }
      }
    });
  }

  // 第一希望日のバツボタンをクリックした際、第一希望日の日付と時刻をリセット
  document.querySelector(".js-date_cancel1")?.addEventListener("click", () => {
    document.getElementById("preferred_date1").value = "";
    if (document.getElementById("reserve_time1")) {
      document.getElementById("reserve_time1").value = "";
    } else if (
      document.getElementById("reserve_hour1") &&
      document.getElementById("reserve_minute1")
    ) {
      document.getElementById("reserve_hour1").value = "";
      document.getElementById("reserve_minute1").value = "";
    }
  });

  // 第二希望日のバツボタンをクリックした際、第二希望日の日付と時刻をリセット
  document.querySelector(".js-date_cancel2")?.addEventListener("click", () => {
    document.getElementById("preferred_date2").value = "";
    if (document.getElementById("reserve_time2")) {
      document.getElementById("reserve_time2").value = "";
    } else if (
      document.getElementById("reserve_hour2") &&
      document.getElementById("reserve_minute2")
    ) {
      document.getElementById("reserve_hour2").value = "";
      document.getElementById("reserve_minute2").value = "";
    }
  });

  // 時刻（時）を変更したとき 00分にセット[通常予約・資料請求のみ]
  document.querySelectorAll("[id^='reserve_hour']").forEach((element) => {
    element.addEventListener("change", (e) => {
      const target = e.currentTarget;
      const timeTargetId = target.id.replace("reserve_hour", "reserve_minute"); // 対応する[分]

      const minutesTarget = document.getElementById(timeTargetId);
      if (minutesTarget) {
        minutesTarget.value = "00";
        // 進捗表示用に日付セットした際にchangeイベント発火させる
        minutesTarget.dispatchEvent(new Event("change"));
      }
    });
  });

  // カレンダーモーダル背景押下でカレンダー閉じる
  document
    .querySelectorAll(".calendar__bg, .calendar__close")
    .forEach((element) => {
      element.addEventListener("click", () => {
        $(".calendar, .calendar__bg").hide();
        return false;
      });
    });

  // ご婚礼予定月の年選択で未定が選択された場合月を選択不可にする
  document
    .querySelector("[id^='marriage_year']")
    ?.addEventListener("change", () => {
      toggleMarriageMonthDisabled();
    });

  document
    .querySelectorAll("form:not([data-enableSubmit])")
    .forEach((element) => {
      element.addEventListener("keydown", (e) => {
        // テキストエリアは改行したいので除外します
        if (
          document.activeElement &&
          document.activeElement.tagName === "TEXTAREA"
        ) {
          return true;
        }

        if (e.key === "Enter") {
          e.preventDefault();
          return false;
        }
        return true;
      });
    });
});
